import { searchContextSuggestionsDictionary } from "shared/Context/constants";
import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";

import useContextsAnalytics from "../useContextsAnalytics";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    trackAnalytics: useContextsAnalytics(),
    searchSuggestionsDictionary: searchContextSuggestionsDictionary,
  })(props);
};

export default useCellFilterAction;
